module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zTVLmR/tc-custom/9781459262102.jpg?1740459907893",
      "alt": "This image is the cover for the book Sheikh's Seduction"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sheikh's Seduction\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("Who was seducing whom?")])]), _c('br'), _c('br'), _vm._v("With her family's future happiness in Tareq al-Khaima's all-controlling hands, Sarah Hillyard was persuaded to become the sheikh's traveling companion for a year. She remembered his gentleness toward her as a young girl, but now she suspected Tareq's scheme was a calculated means of getting closer to the beautiful woman she had becomewith no promise of commitment on his part."), _c('br'), _c('br'), _vm._v("Tareq claimed to have lost the capacity to love and he was so totally self-contained, so "), _c('i', [_vm._v("frustratingly")]), _vm._v(" untouchable that Sarah surprised herself by wanting to find out how he would react if she turned the tablesand set about seducing "), _c('i', [_vm._v("him!")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Emma Darcy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Initially a French/English teacher, Emma Darcy changed careers to computer programming before the happy demands of marriage and motherhood. Very much a people person, and always interested in relationships, she finds the world of romance fiction a thrilling one and the challenge of creating her own cast of characters very addictive.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0